import React, {useRef, useEffect, useState} from 'react';
import {Container, Row, Col} from "react-bootstrap";
import styled from 'styled-components'
import Title from "../../../components/Title";
import {hover, hoverNd} from "../../../globalStyleVars";
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import {BsX} from "react-icons/bs";

import {baseUrl} from "../../../components/BaseUrl";
import BlurImg from "../../../assets/images/blur.jpg";
import ReactHtmlParser from "react-html-parser";


const Item = ({data}) => {
    const [postHeight, setHeight] = useState(0)
    const [slug, setSlug] = useState('')
    const detailRef = useRef(null)
    const closeRef = useRef(null)

    useEffect(() => {

        let getHeight = detailRef && detailRef.current.offsetHeight;
        setHeight(getHeight)

        let getProductClick = document.querySelectorAll('.csr-item');
        getProductClick.forEach(e => {
            e.addEventListener('click', (i) => {
                i.preventDefault();
                if (!detailRef.current.classList.contains('show-detail')) {
                    detailRef.current.classList.add('show-detail')
                }
            })
        })

        closeRef.current.addEventListener('click', () => {
            detailRef.current.classList.remove('show-detail')
        })


    }, [data])

    const handleSlug = (e) => {
        setSlug(e)
    }

    let filterDetail = data ? data.find(f => f.data.slug === `${slug}`) : '';


    let csrPopupImagesData = filterDetail?.images ? filterDetail?.images.filter(e => e.is_thumb !== 'on') : '';
        // let csrImagePath = csrImageData?.path ? baseUrl + csrImageData?.path + csrImageData?.img_name : BlurImg;
    // console.log(csrImageData, 'post images path');


    return (
        <>
            <StyledProduct className='product-list pb-150 as-csr'>
                <Container>
                    <Row>
                        {data && data.map(post => {
                                let thumbImageData = post?.images ? post?.images.find(e => e.is_thumb === 'on') : '';
                                let thumbImagePath = thumbImageData?.path ? baseUrl + thumbImageData?.path + thumbImageData?.img_name : BlurImg;
                                return (
                                    <Col key={post.data.id} sm={4} onClick={() => handleSlug(post.data.slug)}>
                                        <div className="csr-item">
                                            <div className="csr-item__img">
                                                <img src={thumbImagePath} alt=""/>
                                            </div>
                                            <div className="csr-item__content">
                                                <p>{post.data.title}</p>
                                            </div>

                                        </div>
                                    </Col>
                                )
                            }
                        )}
                    </Row>
                </Container>
            </StyledProduct>

            <StyledDetail className='concern-detail' ref={detailRef}>
                <div className="close-detail" ref={closeRef}>
                    <BsX/>
                </div>
                <SimpleBar autoHide={false} style={{maxHeight: postHeight}}>
                    <div className="concern-detail__top">
                        <Title fontSize={40} lineHeight={40} color={'#FFF'} margin={'0 0 80px 0'}
                               text={filterDetail && filterDetail.data.title}/>
                        {ReactHtmlParser(filterDetail && filterDetail.data.description)}
                    </div>

                    <div className="concern-detail__content">
                        <Row>
                            {
                                csrPopupImagesData?csrPopupImagesData.map(popupImage => {
                                    let csrImagePath = popupImage?.path ? baseUrl + popupImage?.path + popupImage?.img_name : BlurImg;
                                    return(
                                        <Col xs={6} className='concern-detail__content__single'>
                                            <img src={csrImagePath} alt=""/>
                                        </Col>
                                    )
                                }):''
                            }
                        </Row>
                    </div>
                </SimpleBar>
            </StyledDetail>
        </>
    )
}


const StyledProduct = styled.section`
  .csr-item {
    margin-bottom: 50px;
    cursor: pointer;

    &__img {
      padding-top: calc(373 / 370 * 100%);
      position: relative;

      img {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        object-fit: cover;
      }

    }

    &__content {
      margin: 34px 0 0 0;

      p {
        font-size: 20px;
        font-weight: bold;
        margin: 0;
        color: #313033;
        line-height: 22px;
        text-transform: uppercase;
      }
    }
  }

`;

const StyledDetail = styled.section`
  width: 65%;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background-color: ${hover};
  height: 100vh;
  //overflow: auto;
  padding: 99px 70px 50px 70px;
  transform: translateX(120%);
  transition: transform 0.8s cubic-bezier(0.33, 1, 0.68, 1);

  &.show-detail {
    transform: none;
  }

  .close-detail {
    height: 32px;
    width: 32px;
    border-radius: 50%;
    background-color: #fff;
    overflow: hidden;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 40px;
    top: 40px;

    svg {
      font-size: 18px;
      color: ${hover};
      z-index: 2;
    }

    &:after {
      content: '';
      background-color: ${hoverNd};
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 50%;
      margin: auto;
      height: 0px;
      width: 0;
      transition: all .3s ease;
    }

    &:hover {
      &:after {
        height: 100%;
        width: 100%;
      }

      svg {
        color: #ffffff;
      }
    }
  }

  .concern-detail__top {
    width: 70%;


    p {
      font-size: 16px;
      color: #ffffff;
      margin-bottom: 20px;
      line-height: 21px;

      &:nth-last-of-type(1) {
        margin-bottom: 0;
      }
    }

    &:hover {
      .simplebar-vertical {
        opacity: 1;
      }
    }

  }

  .concern-detail__content {
    margin-top: 80px;
    margin-bottom: 150px;
    padding-right: 20px;

    &__single {
      margin-bottom: 30px;

      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }

  .simplebar-vertical {
    opacity: 0;
  }

  &:hover {
    .simplebar-vertical {
      opacity: 1;
    }
  }

  @media (max-width: 767px) {
    width: 95%;
    padding: 60px 10px 80px 30px;
    .concern-detail__top {
      width: calc(100% - 20px);

      h2 {
        font-size: 22px !important;
        margin-bottom: 30px;
        line-height: 30px;
      }
    }

    .close-detail {
      top: 20px;
      right: 20px;
    }
  }

`;


export default Item;